/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BestSellingItem } from './BestSellingItem';
import {
    BestSellingItemFromJSON,
    BestSellingItemFromJSONTyped,
    BestSellingItemToJSON,
} from './BestSellingItem';

/**
 * 
 * @export
 * @interface BestSellingResponse
 */
export interface BestSellingResponse {
    /**
     * 
     * @type {Array<BestSellingItem>}
     * @memberof BestSellingResponse
     */
    data?: Array<BestSellingItem>;
}

/**
 * Check if a given object implements the BestSellingResponse interface.
 */
export function instanceOfBestSellingResponse(value: object): value is BestSellingResponse {
    let isInstance = true;

    return isInstance;
}

export function BestSellingResponseFromJSON(json: any): BestSellingResponse {
    return BestSellingResponseFromJSONTyped(json, false);
}

export function BestSellingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BestSellingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(BestSellingItemFromJSON)),
    };
}

export function BestSellingResponseToJSON(value?: BestSellingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(BestSellingItemToJSON)),
    };
}

